export default __webpack_public_path__ + "static/media/meetTeam.05154e1b.svg";